import {useState} from 'react';

import {Header, Body} from './Box';
import plusSolid from '../../../../../assets/plus-solid-space-cadet.png';
import minusSolid from '../../../../../assets/minus-solid-space-cadet.png';
import trashSolid from '../../../../../assets/trash-can-solid-space-cadet.png';

import styles from '../../../../../styles/case/aside/InfoBox.module.scss';

/**
 * @param {string} props.label
 *
 * @param {Object[]} props.content
 * @param {string} props.content.source
 * @param {string} props.content.comment
 * @param {string} props.content.timestamp
 *
 * @param {boolean} props.custom
 */
function InfoBox(props) {
  const [show, setShow] = useState(true);
  const toggle = () => setShow(show => !show);

  function getDateTime(timestampSecOrMs) {
    const timestamp = isNaN(timestampSecOrMs) ? timestampSecOrMs : (timestampSecOrMs > 2000000000 ? timestampSecOrMs : Math.floor(timestampSecOrMs * 1000));
    const ts2str = (ts) => {
      if (ts === 0 || ts === -1) return 'atemporal';
      try {
        return new Date(ts).toISOString().replace('T', ' ').slice(0, -5) + ' GMT';
      } catch {
        return 'invalid timestamp: ' + ts;
      }
    }
    if (!timestamp) return 'undefined timestamp';
    if (!isNaN(timestamp)) return ts2str(timestamp);
    if (timestamp.length === 2 && !isNaN(timestamp[0])) {
      if (timestamp[0] === timestamp[1]) return ts2str(timestamp[0]);
      if (timestamp[0] <= 0 && timestamp[1] >= Date.now()) return 'atemporal';
      return ts2str(timestamp[0]) + ' - ' + ts2str(timestamp[1]);
    }
    let ret = '';
    let i = 0;
    for (let tsInt of timestamp) {
      if (i >= 3 && i < timestamp.length - 2) {
        if (i === 3) ret += '... (' + timestamp.length + ' different timestamps in total)\n';
        i += 1;
        continue;
      }
      if (tsInt[0] === tsInt[1]) ret += ts2str(tsInt[0]) + '\n';
      else ret += ts2str(tsInt[0]) + ' - ' + ts2str(tsInt[1]) + '\n';
      i += 1;
    }
    return ret.trim();
  }

  return (
    <div className={styles.infoBox}>
      <Header className={styles.header} content={props.content} custom={props.custom}>
        <p>{props.label}</p>
        
        <div>
          <div className={show ? styles.minus : styles.plus} onClick={toggle}/>
        </div>
      </Header>
      <Body className={styles.body} show={show}>
        {props.content.map((content, index) =>
          <pre key={index} title={content.source + '\n' + getDateTime(content.timestamp)}>
            {props.custom &&
            <>
              <div className={styles.trash} title="Delete note" onClick={() => props.onDelete(content.noteObj)}>
                <i className="fa fa-trash"></i>
              </div>
              <div className={styles.edit} title="Edit note" onClick={() => props.onEdit(content.noteObj)}>
                <i className="fa fa-pencil"></i>
              </div>
            </>
          }
          
          {content.comment}
          </pre>
        )}
      </Body>
    </div>
  );
}

export default InfoBox;